<template>
  <Modal :style="blockModalIsOpen ? 'display: block' : 'display: none'" :show="blockModalIsOpen" :scrollable="true"
         modal-class="modal-block-number profile-modal" @close="closeModal">
    <template #body>
      <div class="modal-content modal-block-num">
        <button class="buy-number-modal-close-btn block-number-cloe-btn block-number-modal-close-btn"
                @click="closeModal"></button>
        <div class="block-number-content-middle"></div>
        <div class="buy-number-title buy-number-title-gray">
          {{ getLocalization('This country has been blocked for you') }}
          <br>{{ getLocalization('due to your low delivery rate') }} {{ getLocalization('to') }} {{
            blockModalBannedTo
          }} GMT+3
        </div>
        <div class="buy-number-content block-number-content row g-3">
          <div class="block-number-content-first col-12">
            <p>{{ getLocalization('How to increase code deliverability') }}</p>
          </div>
          <div class="d-flex article-btn-wrapper col-12">
            <div class="block-number-content-second">
              <img class="block-number-arrow" src="/img/svg/common/block-arrow.svg" alt=""/>
            </div>
            <div class="buy-number-content-third">
              <a class="button primary fw-bolder block-btn" :href="getLocalization('Article link')">
                <img class="block-svg-article" src="/img/svg/common/check-circle.svg">
                {{ getLocalization('Article') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../components/table/modalNew.vue";

export default {
  name: "blockNumberModal",
  components: {
    Modal
  },
  props: {
    blockModalIsOpen: {
      type: Boolean,
      required: true
    },
    blockModalBannedTo: {
      type: String,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>
<style scoped></style>
